import type { PageId } from "../App";

const ITEMS: Array<{ id: PageId; label: string; icon: string }> = [
  { id: "dashboard", label: "Обзор", icon: "📊" },
  { id: "tasks", label: "Задачи", icon: "📋" },
  { id: "pipeline", label: "Pipeline", icon: "⚡" },
  { id: "jarvis", label: "Jarvis", icon: "🧠" },
  { id: "branches", label: "Ветки", icon: "🌿" },
  { id: "clients", label: "Клиенты", icon: "🏢" },
  { id: "signals", label: "Сигналы", icon: "📡" },
  { id: "chat", label: "Claude", icon: "🤖" },
  { id: "ide", label: "IDE", icon: "💻" },
  { id: "rollouts", label: "Rollouts", icon: "🚀" },
  { id: "settings", label: "Настройки", icon: "⚙️" },
];

export function Sidebar({
  active,
  onNavigate,
}: {
  active: PageId;
  onNavigate: (page: PageId) => void;
}) {
  return (
    <nav className="flex h-full flex-col">
      <div className="border-b border-panel-border p-4">
        <div className="text-lg font-semibold">Coagent Console</div>
        <div className="text-xs text-panel-muted">v0.1.0 · solo-dev panel</div>
      </div>
      <ul className="flex-1 space-y-0.5 p-2">
        {ITEMS.map((it) => (
          <li key={it.id}>
            <button
              onClick={() => onNavigate(it.id)}
              className={
                "flex w-full items-center gap-2 rounded px-3 py-2 text-left text-sm transition " +
                (active === it.id
                  ? "bg-panel-border text-panel-fg"
                  : "text-panel-muted hover:bg-panel-card hover:text-panel-fg")
              }
            >
              <span>{it.icon}</span>
              <span>{it.label}</span>
            </button>
          </li>
        ))}
      </ul>
      <div className="border-t border-panel-border p-3 text-xs text-panel-muted">
        <code>{window.location.host}</code>
      </div>
    </nav>
  );
}
